// extracted by mini-css-extract-plugin
export default {"actions":"counter-agent-table_actions__T1bWK"};